var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.88233C4 2.84275 4.84275 2 5.88233 2H14.1177C15.1573 2 16 2.84275 16 3.88233V16.1177C16 17.1573 15.1573 18 14.1177 18H5.88233C4.84275 18 4 17.1573 4 16.1177V3.88233ZM5.88233 3.49533C5.66859 3.49533 5.49533 3.66859 5.49533 3.88233V16.1177C5.49533 16.3314 5.66859 16.5047 5.88233 16.5047H14.1177C14.3314 16.5047 14.5047 16.3314 14.5047 16.1177V3.88233C14.5047 3.66859 14.3314 3.49533 14.1177 3.49533H5.88233Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48876 14.3459C8.48876 13.933 8.8235 13.5982 9.23642 13.5982H10.7741C11.1871 13.5982 11.5218 13.933 11.5218 14.3459C11.5218 14.7588 11.1871 15.0935 10.7741 15.0935H9.23642C8.8235 15.0935 8.48876 14.7588 8.48876 14.3459Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97818 5.74766C4.97818 5.33474 5.31292 5 5.72584 5H14.5C14.9129 5 15.2477 5.33474 15.2477 5.74766C15.2477 6.16059 14.9129 6.49533 14.5 6.49533H5.72584C5.31292 6.49533 4.97818 6.16059 4.97818 5.74766Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.cd3c125a.svg";
export { ForwardRef as ReactComponent };